import React from "react";
import { Link } from "react-router-dom";
import PaginaEsito from "./esito/PaginaEsito";

// Pagina di esito in italiano, con lo stesso aspetto delle altre pagine di esito
const Error500 = () => (
   <PaginaEsito titolo="Errore del server" variante="danger">
      <p>Si è verificato un errore del server. Riprova fra qualche minuto.</p>
      <Link className="btn btn-primary btn-add" to="/dashboard">
         Torna alla home
      </Link>
   </PaginaEsito>
);

export default Error500;
